// @flow
const config = {
  API_URL: process.env.CIVICPLUS_API_URL || 'https://api.adamelliott.com/',
  API_PATH: process.env.CIVICPLUS_HCMS_SHORTURL || 'vibe/vibe'
}

module.exports = config
